/** Language identifiers are shared by the web app, mail renderer and standalone opener. */
export const LOCALES = {
  en: { name: "English", htmlLang: "en", locale: "en-GB", dir: "ltr" },
  es: { name: "Español", htmlLang: "es", locale: "es-ES", dir: "ltr" },
  fr: { name: "Français", htmlLang: "fr", locale: "fr-FR", dir: "ltr" },
  pt: { name: "Português", htmlLang: "pt-BR", locale: "pt-BR", dir: "ltr" },
  ru: { name: "Русский", htmlLang: "ru", locale: "ru-RU", dir: "ltr" },
  sr: { name: "Srpski", htmlLang: "sr-Latn", locale: "sr-Latn-RS", dir: "ltr" },
  hi: { name: "हिन्दी", htmlLang: "hi", locale: "hi-IN", dir: "ltr" },
  id: { name: "Bahasa Indonesia", htmlLang: "id", locale: "id-ID", dir: "ltr" },
  bn: { name: "বাংলা", htmlLang: "bn", locale: "bn-BD", dir: "ltr" },
  ar: { name: "العربية الفصحى", htmlLang: "ar", locale: "ar", dir: "rtl" },
  zh: { name: "中文（简体）", htmlLang: "zh-Hans", locale: "zh-Hans-CN", dir: "ltr" },
  ur: { name: "اردو", htmlLang: "ur", locale: "ur-PK", dir: "rtl" },
  ja: { name: "日本語", htmlLang: "ja", locale: "ja-JP", dir: "ltr" },
} as const;

export type Lang = keyof typeof LOCALES;
export const LANGS = Object.keys(LOCALES) as Lang[];
export const ADDED_LANGS = ["es", "fr", "pt", "ru", "hi", "id", "bn", "ar", "zh", "ur", "ja"] as const;
export type AddedLang = typeof ADDED_LANGS[number];

export function isLang(value: unknown): value is Lang {
  return typeof value === "string" && Object.hasOwn(LOCALES, value);
}

/** Accept our saved ids and BCP-47 variants sent by document.documentElement.lang. */
export function resolveLang(value: unknown): Lang | null {
  if (typeof value !== "string") return null;
  const code = value.toLowerCase().replaceAll("_", "-").split("-")[0];
  return isLang(code) ? code : null;
}
